import merge from 'lodash/merge';

/**
 * Default Options of the Scroll Tracker
 * @type {{}}
 */
const defaultOptions = {
    background: '#377acf',
    height: '5px',
    events: {
        beforeDraw: () => {},
        afterDraw: () => {},
        beforeCalculate: () => {},
        afterCalculate: () => {}
    }
};

export class ScrollTracker {

    constructor(elementName = 'js-scroll-tracker', options = defaultOptions)
    {
        this.scrollTrackerElement  = this.createElement(elementName)
        this.options = merge(defaultOptions, options);

        this.applyStyle()

        this.calculate()
        this.draw()

        document.addEventListener('scroll', e => {
            this.calculate()
            this.draw()
        })

    }

    /**
     * Creates a new div and prepends it to the body
     * @param elementName
     */
    createElement(elementName)
    {
        let scrollTrackerNode = document.createElement('div')
        scrollTrackerNode.setAttribute('id', elementName)
        scrollTrackerNode.setAttribute('class', 'scroll-tracker')
        document.body.appendChild(scrollTrackerNode)

        this.trackerElement = document.createElement('div')
        this.trackerElement.setAttribute('class', 'js-tracker')
        this.trackerElement.setAttribute('class', 'tracker')

        scrollTrackerNode.appendChild(this.trackerElement)

        return scrollTrackerNode
    }

    /**
     * Apply Default styles
     */
    applyStyle()
    {
        this.trackerElement.style.height = this.options.height;
        this.trackerElement.style.backgroundColor = this.options.background
    }

    /**
     * Calculate scrolling position
     */
    calculate()
    {
        let windowHeight    = window.innerHeight
        let scrollPosition  = window.pageYOffset
        let bodyHeight      = document.body.offsetHeight - windowHeight

        this.options.events.beforeCalculate(this)
        this.scrollPosition = Math.round(scrollPosition / bodyHeight * 100)
        this.options.events.afterCalculate(this)

    }

    /**
     * Draw it in the DOM
     */
    draw()
    {
        this.options.events.beforeDraw(this)
        this.trackerElement.style.width = `${this.scrollPosition}%`
        this.options.events.afterDraw(this)
    }

}